import { selectIsAdmin, useSelector } from '@tunasong/redux'
import { FullPageProgress } from '@tunasong/ui-lib'
import type { FC, ReactNode } from 'react'
import { notFoundElement } from '../not-found.js'

export interface AdminGuardProps {
  children: ReactNode
}

/**
 * The admin status page's guard (admin spec §3.4), inside AppContainer's AuthGuard. It hides the page, it
 * doesn't protect the data: the admin API checks the scope and the group on every request.
 */
export const AdminGuard: FC<AdminGuardProps> = props => {
  const { children } = props
  const isLoggedIn = useSelector(state => state.user.isLoggedIn)
  const isAdmin = useSelector(selectIsAdmin)

  if (!isLoggedIn) {
    return <FullPageProgress />
  }
  if (!isAdmin) {
    return notFoundElement
  }
  return children
}
